import { Component, OnDestroy, afterNextRender, inject } from '@angular/core';
import { FuseSidebarService } from 'fuse-core/components/sidebar/sidebar.service';
import { IackathonWrapperComponent } from 'shared/iackathon-wrapper/iackathon-wrapper.component';

@Component({
  selector: 'app-iackathon-page',
    imports: [
        IackathonWrapperComponent
    ],
  templateUrl: './iackathon-page.component.html',
  styleUrl: './iackathon-page.component.scss',
})
export class IackathonPageComponent implements OnDestroy {
    private fuseSidebarService= inject(FuseSidebarService);

    constructor() {
        afterNextRender(() => {
            this.fuseSidebarService.getSidebar('navbar')?.fold();
        });
    }

    ngOnDestroy(): void {
        this.fuseSidebarService.getSidebar('navbar')?.unfold();
    }
}
